import {useContext} from "react";
import {I18nReactContext} from "../contexts/I18nContext";
import {filter, get} from "lodash"
import {signDocProgressTypes, isSignDocComplete} from "../Components/SignDoc/SignDocLib";

/**
 * Hook that provides learning center utilities with i18n support
 * @returns {object} Object containing learning center functions and data
 */
export const useLearningCenterLib = () => {
    const {i18n} = useContext(I18nReactContext);
    
    const userChartLabels = [
        i18n.translate('home.userChartLabels.finishedCourses'),
        i18n.translate('home.userChartLabels.inProgressCourses'),
        i18n.translate('home.userChartLabels.notStartedCourses')
    ];

    /**
     * Calculates user chart data based on sign documents
     * @param {object} params - The function parameters
     * @param {Array} params.signDocs - Array of sign documents
     * @returns {Array} Array containing [finished, inProgress, notStarted] counts
     */
    const calcUserChartData = ({signDocs}) => {
        const finished = get(filter(signDocs, signDoc => {
            // Use centralized completion logic AND check for completedOnDate
            return isSignDocComplete({signDoc}) || get(signDoc, 'completedOnDate');
        }), 'length', 0)

        const inProgress = get(filter(signDocs, signDoc => {
            if(signDocProgressTypes.includes(get(signDoc, 'signDoc.type'))){
                return get(signDoc ,"progressPercent") && get(signDoc ,"progressPercent") > 0 && get(signDoc ,"progressPercent") < 100
            }
            else{
                return get(signDoc ,"viewed") > 0 && !get(signDoc ,"signed")
            }
        }), 'length', 0)
        const notStarted = get(filter(signDocs, signDoc => {
            if(signDocProgressTypes.includes(get(signDoc, 'signDoc.type'))){
                return !get(signDoc ,"progressPercent")
            }
            else{
                return !get(signDoc ,"viewed") && !get(signDoc ,"signed")
            }
        }), 'length', 0)
        return [finished, inProgress, notStarted]
    };
    
    return {
        userChartLabels,
        calcUserChartData
    };
};